import useRouter from 'use-react-router';
import { useCookies } from 'react-cookie';
import {
  PAP_REFERRAL_COOKIE_NAME,
  REFERRAL_COOKIE_NAME,
} from '@mm/constants/referrals';
import { useEffect } from 'react';
import { handleCookies } from '../../dashboard/pages/RegisterFlow/referrals';

export const useHandleSignupCookies = () => {
  const { location } = useRouter();
  const [cookie, setCookie, removeCookie] = useCookies([
    REFERRAL_COOKIE_NAME,
    PAP_REFERRAL_COOKIE_NAME,
  ]);

  useEffect(() => {
    if (location.search) {
      handleCookies(setCookie, location.search);
    }
  }, []);
};
